const urlbase = window.location.origin;

import { writable } from 'svelte/store';
export const classes = writable([]);
export const getClasses = async () => {
    console.log('fetching classes');
    try {
        const response = await fetch(`${urlbase}/library/wp-json/wp/v2/classes-menu`);
        const data = await response.json();
        const formattedData = data.map(classObj => {
            return {
                id: classObj.id,
                name: classObj.name,
                description: classObj.description,
                children: classObj.children.map(childObj => {
                    return {
                        id: childObj.id,
                        name: childObj.name,
                        description: childObj.description
                    };
                })
            };
        });
        classes.set(formattedData);
        console.log('classes fetched:', formattedData);
    } catch (error) {
        console.error('Error fetching classes:', error);
    }
};

getClasses();
